import { setViewportHeight } from './tool';

/**
 * 初始化视口高度
 *
 * @description
 * 初始化视口高度并监听窗口大小变化事件。
 * 用于解决移动端浏览器（特别是iOS Safari）中100vh不准确的问题。
 * 首先设置一次视口高度，然后添加resize事件监听器以在窗口大小变化时更新高度。
 */
function initViewportHeight() {
  // 初始设置
  setViewportHeight();

  // 监听窗口大小变化
  window.addEventListener('resize', setViewportHeight);
}

export default initViewportHeight;
